import { css, html } from 'lit';
import { map } from 'lit/directives/map.js';
import { range } from 'lit/directives/range.js';
import { FlensSliderController } from './slider-controller';

export class FlensSliderNavigationDots extends FlensSliderController {
	static properties = {
		_count: { type: Number, state: true },
		_activeIndex: { type: Number, state: true },
	};

	static styles = css`
    :host {
      box-sizing: border-box;
      pointer-events: none;
      z-index: 3;
    }

    ul {
      display: flex;
      gap: 0.5rem;
      list-style: none;
      margin: 0;
      padding: 0;
    }

    .dot {
      background-color: var(--dot-color-inactive, gray);
      block-size: var(--dot-size, 1rem);
      border: none;
      border-radius: 50%;
      cursor: pointer;
      inline-size: var(--dot-size, 1rem);
      outline-offset: 0.25rem;
      pointer-events: all;
      transition: 0.3s all ease-out;
    }

    .active {
      background-color: var(--dot-color-active, black);
    }
  `;

	constructor() {
		super();
		this._count = 0;
		this._activeIndex = -1;
		this._onSliderChange = this._onSliderChange.bind(this);
		this._renderDot = this._renderDot.bind(this);
	}

	_updateControlledSlider() {
		this._controlledSlider?.removeEventListener('change', this._onSliderChange);

		super._updateControlledSlider();

		const slider = this._controlledSlider;
		if (slider) {
			slider.updateComplete?.then(this._onSliderChange);
			slider.addEventListener('change', this._onSliderChange);
		} else {
			this._count = 0;
			this._activeIndex = -1;
		}
	}

	_onSliderChange() {
		const { controlledSlider } = this;
		this._count = controlledSlider.count ?? 0;
		this._activeIndex = controlledSlider.activeIndex ?? -1;
	}

	_onClickDot(event) {
		const { index } = event.target.closest('.dot').dataset;
		this.controlledSlider?.moveToIndex(index);
	}

	_renderDot(index) {
		return html`
      <li>
        <button
          class="dot ${this._activeIndex === index ? 'active' : ''}"
          part="dot"
          aria-label="Go to slide ${index + 1}"
          aria-controls="${this.controls ?? null}"
          data-index="${index}"
          @click="${this._onClickDot}"
        ></button>
      </li>
    `;
	}

	render() {
		return html`
      <nav>
        <ul>
          ${map(range(this._count), this._renderDot)}
        </ul>
      </nav>
    `;
	}
}

customElements.define(
	'flens-slider-navigation-dots',
	FlensSliderNavigationDots,
);
